// Ponto único para transformar um erro de chamada de API numa mensagem em
// português segura para mostrar ao usuário final.
//
// Contexto: o backend nem sempre responde em português (algumas exceções não
// tratadas — de bibliotecas, do banco, etc. — vazam com a mensagem original,
// às vezes em inglês) e erros de rede do próprio axios (timeout, "Network
// Error") vêm sempre em inglês, já que nunca chegam a bater no servidor.
// Esta função cobre os casos mais comuns em vez de exibir esse texto cru.
const NETWORK_ERROR_TRANSLATIONS = [
  { match: /network error/i, message: 'Não foi possível conectar ao servidor. Verifique sua internet e tente novamente.' },
  { match: /timeout/i, message: 'O servidor demorou muito para responder. Tente novamente.' },
  { match: /request entity too large/i, message: 'O arquivo enviado é muito grande.' },
  { match: /^request failed with status code \d+$/i, message: 'Algo deu errado. Tente novamente.' },
];

const STATUS_FALLBACKS = {
  400: 'Não foi possível completar a solicitação. Verifique os dados e tente novamente.',
  401: 'Sessão expirada ou credenciais inválidas.',
  403: 'Você não tem permissão para realizar essa ação.',
  404: 'Não encontramos o que você procurou.',
  413: 'O arquivo enviado é muito grande.',
  500: 'Erro interno do servidor. Tente novamente em instantes.',
};

export const GENERIC_ERROR_MESSAGE = 'Algo deu errado. Tente novamente.';

/**
 * @param {*} error erro capturado de uma chamada axios (ou qualquer Error)
 * @param {string} [fallback] mensagem a usar quando nada mais se aplica
 */
export function getErrorMessage(error, fallback = GENERIC_ERROR_MESSAGE) {
  const backendPayload = error?.response?.data;
  const backendMessage =
    (typeof backendPayload === 'string' && backendPayload) ||
    backendPayload?.message ||
    backendPayload?.error;

  if (typeof backendMessage === 'string' && backendMessage.trim()) {
    // Alguns controllers prefixam a mensagem com "Erro: " — mantém só o conteúdo.
    const cleaned = backendMessage.replace(/^Erro?:\s*/i, '').trim();
    const asNetworkError = NETWORK_ERROR_TRANSLATIONS.find(t => t.match.test(cleaned));
    if (asNetworkError) return asNetworkError.message;
    if (cleaned) return cleaned;
  }

  const rawMessage = error?.message;
  if (typeof rawMessage === 'string') {
    const asNetworkError = NETWORK_ERROR_TRANSLATIONS.find(t => t.match.test(rawMessage));
    if (asNetworkError) return asNetworkError.message;
  }

  const status = error?.response?.status;
  if (status && STATUS_FALLBACKS[status]) return STATUS_FALLBACKS[status];

  return fallback;
}
